import React, { useEffect, useState } from "react";
import FileViewer from "react-file-viewer";
import { CloseButton, Container, Overlay, ReaderContainer } from "./styles";
import { getFileBlob } from "../../../services/fileManagement.service";
import { Close } from "@material-ui/icons";

const supportedFileTypes = ["png", "jpg", "jpeg", "pdf", "docx"];

const CustomErrorComponent = ({ error }: any) => <div>{error}</div>;

interface FileReaderProps {
  fileId: string;
  close: () => void;
  actionShowSpinner: (request: any) => any;
  handleOpenUnsupportedFile: (
    blobUrl: string,
    fileName: string,
    fileType: string
  ) => any;
}

const FileReader = ({
  fileId,
  close,
  actionShowSpinner,
  handleOpenUnsupportedFile,
}: FileReaderProps) => {
  const [fileBlobUrl, setFileBlobUrl] = useState<string | null>(null);
  const [fileType, setFileType] = useState<string | null>(null);

  const onError = (e: any) => {
    console.error("e: ", e);
  };

  const onClose = () => {
    close();
  };

  useEffect(() => {
    const fetchFile = async () => {
      actionShowSpinner(true);

      try {
        const { data, headers } = await getFileBlob(fileId);
        const blobUrl = URL.createObjectURL(data);

        const contentDisposition = headers["content-disposition"];
        let fileName = "unknown";
        let fileType = "unknown";

        if (contentDisposition && contentDisposition.includes("filename")) {
          fileName = contentDisposition
            .split("filename")[1]
            .split(";")[0]
            .replace(/['"]/g, "");

          fileType = fileName.split(".").pop() || "unknown";
        }

        if (!supportedFileTypes.includes(fileType)) {
          handleOpenUnsupportedFile(blobUrl, fileName, fileType);
          return;
        }

        setFileBlobUrl(blobUrl);
        setFileType(fileType);
      } catch (error) {
        onError(error);
      } finally {
        actionShowSpinner(false);
      }
    };

    fetchFile();
  }, []);

  return (
    <ReaderContainer>
      <Container>
        <Overlay onClick={onClose} />

        {fileBlobUrl && (
          <FileViewer
            fileType={fileType}
            filePath={fileBlobUrl}
            errorComponent={CustomErrorComponent}
            onError={onError}
          />
        )}

        <CloseButton onClick={onClose}>
          <Close />
        </CloseButton>
      </Container>
    </ReaderContainer>
  );
};

export default FileReader;
